import { render, staticRenderFns } from "./SelectFileField.vue?vue&type=template&id=cf079868&scoped=true"
import script from "./SelectFileField.vue?vue&type=script&lang=js"
export * from "./SelectFileField.vue?vue&type=script&lang=js"
import style0 from "./SelectFileField.vue?vue&type=style&index=0&id=cf079868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf079868",
  null
  
)

export default component.exports